import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import TableGrid from "./TableGrid";
import WheelChart from "../charts/WheelChart";
import "./download.css";
import JSCookie from "js-cookie";
import { resetCurrentMVOCDetail } from "../../features/product/projectSlice";
import { useDispatch } from "react-redux";

function DownloadFile({ forceTableView = false,onDataUpdate }) {
  // Use Navigation
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const backToHomePage = () => {
    navigate("/voc-input");
  };

  const FetchToken = () => {
    if (!JSCookie.get("inizionavigator")) return null;
    const token = JSON.parse(JSCookie.get("inizionavigator")).token;
    return token;
  };
  const Acctoken = FetchToken();

  // Define Variable
  const user_name = localStorage.getItem("loginUserId");
  // Use state data, redireact from upload file to download and chart screen
  const { state } = useLocation();
  // Define state for check Radio button state toggle option
  const [checkedRadioBtn, setCheckedRadioBtn] = useState(!forceTableView);
  // Define state for check button download state
  const [isFileDownloaded, setIsFileDownloaded] = useState(false);
  // This funtion use for check radio button state to update button state
  const changeHandler = () => {
    setCheckedRadioBtn(!checkedRadioBtn);
  };

  useEffect(() => {
    setCheckedRadioBtn(!forceTableView);
  }, [forceTableView]);
  const userBlobFolderName = localStorage.getItem("blobFolder");
  const currentData = state?.response ;
  const data = state;
  console.log("currentData>>>>>>>>>>>>>>",state);
  // Create a new object for the required format
  const requiredData = {
    df_fig: {
      SI: {},
    },
    file_name1: currentData?.file_name1,
    file_name2: currentData?.file_name2,
  };
  useEffect(() => {
    if (!currentData || !data) {
      // debugger;
      navigate('/');
      return // Navigate to root if currentData or data is not present
    }
    if (onDataUpdate && data) {
      onDataUpdate(data); // Send data to parent
    }
  }, [data, onDataUpdate,currentData, navigate]);

 
  

  if (currentData?.df_fig?.SI) {
    // Loop through the "SI" and "Primary_Themes" objects in the current data
    for (const key in currentData?.df_fig.SI) {
      const siValue = currentData?.df_fig.SI[key];
      const theme = currentData?.df_fig.Primary_Themes[key];
      const count = currentData?.df_fig.Count[key];
  
      if (!(siValue in requiredData.df_fig.SI)) {
        requiredData.df_fig.SI[siValue] = {
          count: 0,
        };
      }
  
      if (!(theme in requiredData?.df_fig?.SI[siValue])) {
        requiredData.df_fig.SI[siValue][theme] = count;
      } else {
        requiredData.df_fig.SI[siValue][theme] += count;
      }
  
      requiredData.df_fig.SI[siValue].count += count;
    }
  }else{

  }


  
  useEffect(() => {
    dispatch(resetCurrentMVOCDetail())
  }, []);
  if (!currentData || !data) {
    return null; // Prevent rendering the component until the data is available
  }
  return (
    <>
      <div className="download-sec">
        <div className="d-flex align-items-center tab-heading-sec">

        </div>
        {/* //// chart view */}
        {/* check condition for toggle option  */}
        {checkedRadioBtn ? (
          <div className="row chart-view">
            <div className="col">
              <div className="wheel-chart-section">
                <WheelChart requiredData={state?.response} />
              </div>
            </div>
          </div>
        ) : (
          //// table view
          <div className="row">
            <div className="col h-100">
              <div className="table-sec" style={{  overflowY: 'auto' }}>
                <TableGrid requiredData={state?.response} />
              </div>
            </div>
          </div>
        )}
        {/* #END  */}
      </div>
    </>
  );
}

export default DownloadFile;
